import GroupsView from '@/views/Groups/GroupsView.vue'

export default [
  {
    path: '/merchants/:merchantID?/groups',
    meta: {
      require_roles: ['super_admin', 'admin', 'staff']
    },
    component: GroupsView,
    name: 'GroupList'
  }
]
